import { render, staticRenderFns } from "./PageHeaderLoader.vue?vue&type=template&id=00a9e8b8"
import script from "./PageHeaderLoader.vue?vue&type=script&lang=js"
export * from "./PageHeaderLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports